<template>
  <BaseModal v-model:is-open="isOpen">
    <template #title>
      <div class="d-flex justify-center align-center title-font">
        <img
          v-if="isWarning === true"
          src="~/assets/images/icons/ic_warning.png"
          class="mr-3 icons"
        />
        <img
          v-else
          src="~/assets/images/icons/ic_information_slab_circle.svg"
          class="mr-3 icons"
        />
        確認
      </div>
    </template>
    <template #contents>
      <span class="body-font">{{ message }}</span>
    </template>
    <template #actionButtons>
      <CustomButton
        width="100%"
        :color="isWarning ? 'danger' : 'primary'"
        :variant="isWarning ? 'outlined' : 'flat'"
        size="md"
        @click="accept"
      >
        {{ acceptButtonText }}
      </CustomButton>
      <CustomButton
        width="100%"
        color="primary"
        variant="text"
        size="md"
        class="mt-3"
        @click="cancel"
      >
        {{ cancelButtonText }}
      </CustomButton>
    </template>
  </BaseModal>
</template>

<script setup lang="ts">
import BaseModal from '../base/BaseModal.vue';
import CustomButton from '~/components/common/parts/CustomButton.vue';

const isOpen = defineModel<boolean>('isOpen');

withDefaults(defineProps<{
  message: string;
  isWarning: boolean;
  acceptButtonText?: string;
  cancelButtonText?: string;
}>(), {
  acceptButtonText: 'OK',
  cancelButtonText: 'キャンセル',
});
const emits = defineEmits(['accept', 'cancel']);

const accept = () => {
  isOpen.value = false;
  emits('accept');
};

const cancel = () => {
  isOpen.value = false;
  emits('cancel');
};
</script>

<style lang="scss" scoped>
.icons {
  width: 2rem;
  height: 2rem;
}

.title-font {
  font-size: 1.5rem !important;
  font-weight: bold;
}

.body-font {
  font-size: 1.25rem !important;
  font-weight: 300;
}
</style>
